/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme = window.PXUTheme || {};

window.PXUTheme.jsSlideshowWithText = {
  init: function($section) {

    // --- Schema data ---
    const data = window.PXUTheme.getSectionData($section);
    const textTransition = data.text_transition;
    const imageTransition = data.image_transition;
    const slideCount = data.number_of_slides;
    const showArrows = data.show_arrows;
    const showDots = data.show_nav_buttons;
    const autoPlaySpeed = data.image_slideshow_speed > 0 ? data.image_slideshow_speed * 1000 : false;

    // --- Elements ---
    const $imageSlideshowEl = $section.find('[data-image-slideshow]').removeClass('is-hidden');
    const $textSlideshowEl  = $section.find('[data-text-slideshow]').removeClass('is-hidden');

    // --- Image slideshow ---
    const $imageSlideshow = $imageSlideshowEl.flickity({
      contain: true,
      wrapAround: true,
      prevNextButtons: slideCount > 1 ? showArrows : false,
      pageDots: false,
      draggable: true,
      imagesLoaded: true,
      fade: imageTransition === 'fade',   // ✅ THIS enables fade support
      autoPlay: autoPlaySpeed,
      arrowShape: arrowShape
    });

    // --- Text slideshow ---
    const $textSlideshow = $textSlideshowEl.flickity({
      autoplay: false,
      contain: true,
      imagesLoaded: true,
      lazyload: 4,
      prevNextButtons: false,
      pageDots: slideCount > 1 ? showDots : false,
      draggable: false,
      on: {
        ready: function() {
          const $currentText = $textSlideshowEl.find('.is-selected .text-slideshow__content');
          window.PXUTheme.animation.slideTransition($currentText, textTransition);
        }
      }
    });

    // --- Sync image & text slides ---
    $imageSlideshow.on('change.flickity', function(event, index) {
      $textSlideshow.flickity('select', index, true, true);
      const $currentText = $textSlideshowEl.find('.is-selected .text-slideshow__content');
      window.PXUTheme.animation.slideTransition($currentText, textTransition);
    });

    $textSlideshow.on('change.flickity', function(event, index) {
      $imageSlideshow.flickity('select', index, true, false);
    });

    // --- Arrow container wrapper ---
    $section.find('.flickity-button').wrapAll('<div class="flickity-buttons-container"></div>');
  },

  // --- When block selected in theme editor ---
  blockSelect: function($section, blockId) {
    const $slider = $section.find('[data-image-slideshow]');
    const slideIndex = $('#shopify-section-' + blockId).data('slide-index');
    $slider.flickity('select', slideIndex, true, true);
    setTimeout(function() { $slider.flickity('resize'); }, 500);
  },

  // --- Unload cleanup ---
  unload: function($section) {
    $section.find('.flickity-button').unwrap();
  }
};
/******/ })();
